import React, { Component } from 'react';
import { connect } from 'react-redux';
import MyAccountView from './MyAccount.view';

export class MyAccountContainer extends Component {

  constructor(props){
    super(props);
    this.toggleModal = this.toggleModal.bind(this);
    this.onFormUpdate = this.onFormUpdate.bind(this);
    this.submitForm = this.submitForm.bind(this);
  }

  componentDidMount(){
    const { dispatch } = this.props;
    dispatch({
      type: 'FETCH_MY_ACCOUNT',
    });
  }

  toggleModal(active) {
    const { dispatch } = this.props;
    dispatch({
      type: 'TOGGLE_PASSWORD_CHANGE_MODAL',
      payload: {
        active,
      }
    });
  }

  onFormUpdate(formState, actions) {
    const { dispatch } = this.props;
    dispatch({
      type: 'ON_CHANGE_PASSWORD_FORM_UPDATE',
      payload: {
        formState,
      },
    });
  }

  submitForm(formState) {
    const { dispatch } = this.props;
    dispatch({
      type: 'CHANGE_PASSWORD',
      payload: {
        data: formState.data,
      },
    });
  }

  render() {
    return (<MyAccountView
      {...this.props}
      toggleModal={this.toggleModal}
      onFormUpdate={this.onFormUpdate}
      submitForm={this.submitForm}
    />);
  }

}

function mapStateToProps(state) {
  const { myAccount } = state;
  const { user, changePasswordModalActive, changePasswordFormState } = myAccount;
  return {
    user,
    changePasswordModalActive,
    changePasswordFormState,
  };
}

export default connect(mapStateToProps)(MyAccountContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/MyAccount/MyAccount.container.js